export const MENU_CONFIG = [
  "HomeEdit",
  "ParamEdit",
  "NationList",
  "ImageList",
  "FileList",
  "ActivityList",
  "VideoList",
  "MagazineList",
  "ColumnList",
  "FaqList",
  "MeetingList",
  "EuroFileList",
  // "ReportPage"
];

export const BADGE_COLOR_MAP = {
  // DEPRECATED
  UNPAID: "default",
  PACKING: "processing",
  SHIPPING: "processing",
  ARRIVED: "success",
  CANCEL: "warning",
  //
  PENDING: "processing",
  COMFIRMED: "processing",
  COMPLETED: "success",
  CANCELLED: "warning",
  HOT: "#e53935",
  DRAFT: "#e53935",
  SENT: "#51c41b",
  SCHEDULED: "#ffd600",
  ON: "#51c41b",
  ERROR: "#d9d9d9",
  OFF: "#d9d9d9",
  "": "error",
  [undefined]: "error"
};

export const PAYMENT_APPLY_LINK = {
  payment: {
    linepay: "https://pay.line.me/portal/tw",
    ecpay: "https://www.ecpay.com.tw/",
    newebpay: "https://www.newebpay.com/"
  },
  invoice: {
    ECPAY: "https://www.ecpay.com.tw/Business/invoice",
    NEWEBPAY: "https://inv.ezpay.com.tw/"
  }
};
export const host =
  process.env.REACT_APP_API_MODE === "local"
    ? process.env.REACT_APP_API_LOCAL_HOST
    : process.env.REACT_APP_API_MODE === "product"
    ? process.env.REACT_APP_API_HOST
    : process.env.REACT_APP_API_DEV_HOST;

export const front_end_domain =
  process.env.REACT_APP_API_MODE === "product"
    ? process.env.REACT_APP_FRONT_END_PRODUCT_DOMAIN
    : process.env.REACT_APP_FRONT_END_DEV_DOMAIN;

export const image_domain =
  process.env.REACT_APP_API_HOST === "product"
    ? process.env.REACT_APP_IMAGE_PRODUCT_DOMAIN
    : process.env.REACT_APP_IMAGE_DEV_DOMAIN;
